// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import ActionBar from '../../layout/ActionBar';
import PackageTypeForm from './components/PackageTypeForm';
import DeletePackageType from './slideout/DeletePackageType';
import {
  getPackageTypeById,
  savePackageType,
} from '../../../actions/packageTypeActions';
import Loading from '../../common/Loading';
import SlidingPane from 'react-sliding-pane';
import { useTranslation } from 'react-i18next';
import Button from '../../common/Button';
import ResponsiveActionBarButtons from '../../common/ResponsiveActionBarButtons';
import { usePageTitle } from '../../../util/pageTitle';
import { useNavigate, useParams } from 'react-router-dom';

function PackageType({ savePackageType }) {
  const { id } = useParams();
  const [pageTitle, setPageTitle] = usePageTitle(['Package types', 'Settings']);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const [deleteSlideoutOpen, setDeleteSlideoutOpen] = useState(false);
  const [packageType, setPackageType] = useState({});

  const onSubmit = async (data) => {
    try {
      const response = await savePackageType({ ...packageType, ...data });

      setPackageType({ ...packageType, ...response });

      toast.success(t('Package type saved'));
    } catch (ex) {
      console.error(ex);
      toast.error(t('Failed to save package type'));
    }
  };

  const handleDelete = (e) => {
    e.cancelBubble = true;
    setDeleteSlideoutOpen(true);
    return false;
  };

  useEffect(() => {
    if (id) {
      getPackageTypeById(id)
        .then((d) => {
          setPackageType(d);
          setPageTitle([d.name, 'Package types', 'Settings']);
        })
        .catch((e) => {
          console.error(e);
          navigate('/settings/package-types/');
          toast.error(t('Package type not found'));
        });
    }
  }, [id, t, setPageTitle, navigate]);

  return packageType ? (
    <>
      <ActionBar
        breadcrumb={[
          { link: '/settings/package-types', label: t('Package types') },
          { label: packageType.name },
        ]}
      >
        <div className="d-flex">
          <ResponsiveActionBarButtons
            buttons={[
              id && (
                <Button
                  testId="delete-package-type-button"
                  className="btn btn-danger mx-2 d-none d-md-inline-flex"
                  onClick={handleDelete}
                  text={t('Delete')}
                />
              ),
              <Button
                testId="save-package-type-button"
                key="save"
                className="btn btn-primary"
                onClick={handleSubmit(onSubmit)}
                text={t('Save')}
              />,
            ]}
          />
        </div>
      </ActionBar>
      <PackageTypeForm
        packageType={packageType}
        register={register}
        errors={errors}
        control={control}
        setPackageType={setPackageType}
      />

      <SlidingPane
        isOpen={deleteSlideoutOpen}
        hideHeader={true}
        from="right"
        className="small-side-panel"
        onRequestClose={() => setDeleteSlideoutOpen(false)}
      >
        <DeletePackageType
          id={id}
          done={(d) => {
            setDeleteSlideoutOpen(false);
            navigate('/settings/package-types/');
          }}
          cancel={() => setDeleteSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  ) : (
    <Loading></Loading>
  );
}

const mapDispatchToProps = {
  savePackageType,
};

export default connect(null, mapDispatchToProps)(PackageType);
